import { v } from './vars';

export const assetPath = (path) => (path ? `${v('assetsHost')}${path}` : '');
export const defaultAssetPath = (path) => (path ? `${v('defaultAssetsHost')}${path}` : '');

export const cmsAssetPath = (path) => (path ? `${v('cmsAssetsHost')}${path}`.replace(/'/g, '%27') : '');
export const defaultCmsAssetPath = (path) => (path ? `${v('defaultCmsAssetsHost')}${path}` : '');

// Active storage images
export const cmsImagePath = (path) => (path ? `${v('defaultCmsAssetsHost')}/${path}` : '');
